export default "__VITE_ASSET__B$_Tsu$J__"